/* eslint-disable */
import * as Types from '../../../clients/graphqlTypes.js';

import { gql } from '@apollo/client';
import { AttachmentSnapshotFragmentDoc, ProductAttachmentSnapshotFragmentDoc, AttachmentsFragmentDoc, WithItemAttachmentsFragmentDoc } from '../../features/attachments/Attachments.generated.js';
import { AddressDetails__AddressFragmentDoc } from '../../features/addresses/Addresses.generated.js';
import { TimeReportHeader__ProjectFragmentDoc } from '../../features/time-reports/components/TimeReportHeader.generated.js';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type TimeReportQueryVariables = Types.Exact<{
  projectId: Types.Scalars['ID']['input'];
  reportId: Types.Scalars['ID']['input'];
}>;


export type TimeReportQuery = { project: { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } | { __typename: 'ProjectResult', project?: { __typename: 'Project', id: string, title: string, viewerPermissions: Array<Types.PermissionName>, number: string, timeReport?: { __typename: 'TimeReport', id: string, number: string, approvedAt?: any | null, createdAt: any, fromDate: any, tillDate: any, tasksDescription?: any | null, file?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null, timeReportTexts?: { __typename: 'TimeReportTexts', id: string, opening: string, closing: string } | null, contracteeSignature?: { __typename: 'SignatureExtended', id: string, place: string, date: any, attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } | null, contractorSignature?: { __typename: 'SignatureExtended', id: string, place: string, date: any, attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } | null, items: Array<{ __typename: 'TimeReportItem', id: string, date: any, duration: number, assignee: { __typename: 'User', id: string, firstname: string, familyname: string } }>, organisation: { __typename: 'Organisation', id: string, title: string, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, representive?: { __typename: 'User', id: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }> } | null } } | null, building?: { __typename: 'Building', id: string, buildingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null, crmOrganisation?: { __typename: 'CrmCompany', id: string, title: string, description: string, website: string, isMeister: boolean, number: string, contactPerson?: { __typename: 'CrmPerson', id: string, title: Types.Salutation, description: string, website?: string | null, isMeister: boolean, familyname: string, firstname: string, fullname: string, locale: string, categories: Array<string> } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null } | null } | null }, organisationDocumentSettings: { __typename: 'DocumentSettings', id: string, timeReportTexts: { __typename: 'OrganisationPdfTexts', id: string, opening?: string | null, closing?: string | null } } | { __typename: 'MissingCapabilities' } | { __typename: 'MissingPermissions' } };

export type TimeReport__ContractorFragment = { __typename: 'Organisation', id: string, title: string, billingAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, branchAddress?: { __typename: 'Address', id: string, streetLines1: string, city: string, postalCode: string, countryCode: string, location?: { __typename: 'Location', lat: number, lng: number } | null } | null, representive?: { __typename: 'User', id: string, fullname: string, email: any, phones: Array<{ __typename: 'Phone', id: string, number: string }> } | null };

export type TimeReportItem__EntityFragment = { __typename: 'TimeReportItem', id: string, date: any, duration: number, assignee: { __typename: 'User', id: string, firstname: string, familyname: string } };

export type ModifyTimeReportTextsMutationVariables = Types.Exact<{
  input: Types.ModifyTimeReportInput;
}>;


export type ModifyTimeReportTextsMutation = { modifyTimeReport: { __typename: 'ModifyTimeReportResult', timeReport: { __typename: 'TimeReport', id: string, tasksDescription?: any | null, timeReportTexts?: { __typename: 'TimeReportTexts', id: string, opening: string, closing: string } | null } } };

export type SignTimeReportMutationVariables = Types.Exact<{
  input: Types.ModifyTimeReportInput;
}>;


export type SignTimeReportMutation = { modifyTimeReport: { __typename: 'ModifyTimeReportResult', timeReport: { __typename: 'TimeReport', id: string, contracteeSignature?: { __typename: 'SignatureExtended', id: string, place: string, date: any, attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } | null, contractorSignature?: { __typename: 'SignatureExtended', id: string, place: string, date: any, attachment: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } } | null } } };

export type ApproveTimeReportMutationVariables = Types.Exact<{
  input: Types.ApproveTimeReportInput;
}>;


export type ApproveTimeReportMutation = { approveTimeReport: { __typename: 'ApproveTimeReportResult', timeReport: { __typename: 'TimeReport', id: string, approvedAt?: any | null, file?: { __typename: 'AttachmentSnapshot', id: string, title: string, mimeType: string, url: string, group: string } | null } } };

export const TimeReport__ContractorFragmentDoc = gql`
    fragment TimeReport__Contractor on Organisation {
  id
  title
  billingAddress {
    ...AddressDetails__Address
  }
  branchAddress {
    ...AddressDetails__Address
  }
  representive {
    id
    fullname
    phones {
      id
      number
    }
    email
  }
}
    ${AddressDetails__AddressFragmentDoc}`;
export const TimeReportItem__EntityFragmentDoc = gql`
    fragment TimeReportItem__Entity on TimeReportItem {
  id
  assignee {
    id
    firstname
    familyname
  }
  date
  duration
}
    `;
export const TimeReportDocument = gql`
    query TimeReport($projectId: ID!, $reportId: ID!) {
  project(id: $projectId) {
    ... on ProjectResult {
      project {
        id
        title
        viewerPermissions
        timeReport(id: $reportId) {
          id
          number
          file {
            ...AttachmentSnapshot
          }
          approvedAt
          createdAt
          fromDate
          tillDate
          timeReportTexts {
            id
            opening
            closing
          }
          contracteeSignature {
            id
            place
            date
            attachment {
              ...AttachmentSnapshot
            }
          }
          contractorSignature {
            id
            place
            date
            attachment {
              ...AttachmentSnapshot
            }
          }
          tasksDescription
          items {
            id
            ...TimeReportItem__Entity
          }
          organisation {
            ...TimeReport__Contractor
          }
        }
        building {
          id
          buildingAddress {
            ...AddressDetails__Address
          }
        }
        ...TimeReportHeader__Project
      }
    }
  }
  organisationDocumentSettings {
    ... on DocumentSettings {
      id
      timeReportTexts {
        id
        opening
        closing
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}
${TimeReportItem__EntityFragmentDoc}
${TimeReport__ContractorFragmentDoc}
${AddressDetails__AddressFragmentDoc}
${TimeReportHeader__ProjectFragmentDoc}`;

/**
 * __useTimeReportQuery__
 *
 * To run a query within a React component, call `useTimeReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReportQuery({
 *   variables: {
 *      projectId: // value for 'projectId'
 *      reportId: // value for 'reportId'
 *   },
 * });
 */
export function useTimeReportQuery(baseOptions: Apollo.QueryHookOptions<TimeReportQuery, TimeReportQueryVariables> & ({ variables: TimeReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReportQuery, TimeReportQueryVariables>(TimeReportDocument, options);
      }
export function useTimeReportLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReportQuery, TimeReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReportQuery, TimeReportQueryVariables>(TimeReportDocument, options);
        }
export function useTimeReportSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TimeReportQuery, TimeReportQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TimeReportQuery, TimeReportQueryVariables>(TimeReportDocument, options);
        }
export type TimeReportQueryHookResult = ReturnType<typeof useTimeReportQuery>;
export type TimeReportLazyQueryHookResult = ReturnType<typeof useTimeReportLazyQuery>;
export type TimeReportSuspenseQueryHookResult = ReturnType<typeof useTimeReportSuspenseQuery>;
export type TimeReportQueryResult = Apollo.QueryResult<TimeReportQuery, TimeReportQueryVariables>;
export const ModifyTimeReportTextsDocument = gql`
    mutation ModifyTimeReportTexts($input: ModifyTimeReportInput!) {
  modifyTimeReport(input: $input) {
    timeReport {
      id
      timeReportTexts {
        id
        opening
        closing
      }
      tasksDescription
    }
  }
}
    `;
export type ModifyTimeReportTextsMutationFn = Apollo.MutationFunction<ModifyTimeReportTextsMutation, ModifyTimeReportTextsMutationVariables>;

/**
 * __useModifyTimeReportTextsMutation__
 *
 * To run a mutation, you first call `useModifyTimeReportTextsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useModifyTimeReportTextsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [modifyTimeReportTextsMutation, { data, loading, error }] = useModifyTimeReportTextsMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useModifyTimeReportTextsMutation(baseOptions?: Apollo.MutationHookOptions<ModifyTimeReportTextsMutation, ModifyTimeReportTextsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ModifyTimeReportTextsMutation, ModifyTimeReportTextsMutationVariables>(ModifyTimeReportTextsDocument, options);
      }
export type ModifyTimeReportTextsMutationHookResult = ReturnType<typeof useModifyTimeReportTextsMutation>;
export type ModifyTimeReportTextsMutationResult = Apollo.MutationResult<ModifyTimeReportTextsMutation>;
export type ModifyTimeReportTextsMutationOptions = Apollo.BaseMutationOptions<ModifyTimeReportTextsMutation, ModifyTimeReportTextsMutationVariables>;
export const SignTimeReportDocument = gql`
    mutation SignTimeReport($input: ModifyTimeReportInput!) {
  modifyTimeReport(input: $input) {
    timeReport {
      id
      contracteeSignature {
        id
        place
        date
        attachment {
          ...AttachmentSnapshot
        }
      }
      contractorSignature {
        id
        place
        date
        attachment {
          ...AttachmentSnapshot
        }
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type SignTimeReportMutationFn = Apollo.MutationFunction<SignTimeReportMutation, SignTimeReportMutationVariables>;

/**
 * __useSignTimeReportMutation__
 *
 * To run a mutation, you first call `useSignTimeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSignTimeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [signTimeReportMutation, { data, loading, error }] = useSignTimeReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSignTimeReportMutation(baseOptions?: Apollo.MutationHookOptions<SignTimeReportMutation, SignTimeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SignTimeReportMutation, SignTimeReportMutationVariables>(SignTimeReportDocument, options);
      }
export type SignTimeReportMutationHookResult = ReturnType<typeof useSignTimeReportMutation>;
export type SignTimeReportMutationResult = Apollo.MutationResult<SignTimeReportMutation>;
export type SignTimeReportMutationOptions = Apollo.BaseMutationOptions<SignTimeReportMutation, SignTimeReportMutationVariables>;
export const ApproveTimeReportDocument = gql`
    mutation ApproveTimeReport($input: ApproveTimeReportInput!) {
  approveTimeReport(input: $input) {
    timeReport {
      id
      approvedAt
      file {
        ...AttachmentSnapshot
      }
    }
  }
}
    ${AttachmentSnapshotFragmentDoc}`;
export type ApproveTimeReportMutationFn = Apollo.MutationFunction<ApproveTimeReportMutation, ApproveTimeReportMutationVariables>;

/**
 * __useApproveTimeReportMutation__
 *
 * To run a mutation, you first call `useApproveTimeReportMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveTimeReportMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveTimeReportMutation, { data, loading, error }] = useApproveTimeReportMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useApproveTimeReportMutation(baseOptions?: Apollo.MutationHookOptions<ApproveTimeReportMutation, ApproveTimeReportMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ApproveTimeReportMutation, ApproveTimeReportMutationVariables>(ApproveTimeReportDocument, options);
      }
export type ApproveTimeReportMutationHookResult = ReturnType<typeof useApproveTimeReportMutation>;
export type ApproveTimeReportMutationResult = Apollo.MutationResult<ApproveTimeReportMutation>;
export type ApproveTimeReportMutationOptions = Apollo.BaseMutationOptions<ApproveTimeReportMutation, ApproveTimeReportMutationVariables>;